import styled, { css } from 'styled-components';

export const FormContainer = styled.div`
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.08);
  background: white;
  border: 1px solid #eaeaea;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 1.75rem 1.5rem 1.85rem 1.5rem;
  ${(props) =>
    props.last &&
    css`
      margin-bottom: 5rem;
    `};
`;

export const Separator = styled.hr`
  border: 0;
  border-bottom: 1px solid #c7bdae;
  margin: 0.75rem -0.1rem 0.6rem -0.1rem;
  opacity: 0.35;
`;
